import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from '../services/http/http.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderService } from '../services/loader/loader.service';
import { interval } from 'rxjs/observable/interval';
import { FADE_IN } from '../util/animations/animation';
import { Auth0Service } from '../authentication/auth0/auth0.service';

const source = interval(1000);

interface ParamsData {
  token: string,
  type: string,
  drawingId: string
}

/**
 * This component is used to show the drawing details.
 * 
 * User can participate in one of the drawings by entering the email and points 
 * 
 * It displays the list of raffle tickets which are available with user
 */

@Component({
  selector: 'app-drawing-landing-page',
  templateUrl: './drawing-landing-page.component.html',
  styleUrls: ['./drawing-landing-page.component.scss'],
  animations: [FADE_IN]
})
export class DrawingLandingPageComponent implements OnInit {

  redeemPointForm: FormGroup;
  showLoader = false;
  paramsData: ParamsData;
  accessToken = "";
  practiceLogoUrl = 'https://www.carecognitics.com/wp-content/uploads/2018/10/icon.png';

  drawingDetails: any = {};
  awardRuleDeatils: any = {};
  rewards = [];
  rewardTicket = [];
  // [{"resourceType":"Reward","id":"e9f79562-960c-4141-bfcc-5029aacc17a0","patient":{"reference":"Patient/0f8f87d4-6fbf-4585-87c5-2a0518d18a14"},"rewardType":"Ticket","drawing":{"reference":"Drawing/c7ebbcf1-785a-4d63-a5ec-e45a8521da7c"},"status":"Active","awardDate":"2019-12-10T06:04:04Z","ticketNo":"651-856-7148","email":"yshublikar@chirpn.com","valueQuantity":{"unit":"Ticket","value":1}},
  // {"resourceType":"Reward","id":"e9f79562-960c-4141-bfcc-5029aacc17a0","patient":{"reference":"Patient/0f8f87d4-6fbf-4585-87c5-2a0518d18a14"},"rewardType":"Ticket","drawing":{"reference":"Drawing/c7ebbcf1-785a-4d63-a5ec-e45a8521da7c"},"status":"Active","awardDate":"2019-12-10T06:04:04Z","ticketNo":"651-856-7148","email":"yshublikar@chirpn.com","valueQuantity":{"unit":"Ticket","value":1}},
  // {"resourceType":"Reward","id":"e9f79562-960c-4141-bfcc-5029aacc17a0","patient":{"reference":"Patient/0f8f87d4-6fbf-4585-87c5-2a0518d18a14"},"rewardType":"Ticket","drawing":{"reference":"Drawing/c7ebbcf1-785a-4d63-a5ec-e45a8521da7c"},"status":"Active","awardDate":"2019-12-10T06:04:04Z","ticketNo":"651-856-7148","email":"yshublikar@chirpn.com","valueQuantity":{"unit":"Ticket","value":1}},
  // {"resourceType":"Reward","id":"e9f79562-960c-4141-bfcc-5029aacc17a0","patient":{"reference":"Patient/0f8f87d4-6fbf-4585-87c5-2a0518d18a14"},"rewardType":"Ticket","drawing":{"reference":"Drawing/c7ebbcf1-785a-4d63-a5ec-e45a8521da7c"},"status":"Active","awardDate":"2019-12-10T06:04:04Z","ticketNo":"651-856-7148","email":"yshublikar@chirpn.com","valueQuantity":{"unit":"Ticket","value":1}},
  // {"resourceType":"Reward","id":"e9f79562-960c-4141-bfcc-5029aacc17a0","patient":{"reference":"Patient/0f8f87d4-6fbf-4585-87c5-2a0518d18a14"},"rewardType":"Ticket","drawing":{"reference":"Drawing/c7ebbcf1-785a-4d63-a5ec-e45a8521da7c"},"status":"Active","awardDate":"2019-12-10T06:04:04Z","ticketNo":"651-856-7148","email":"yshublikar@chirpn.com","valueQuantity":{"unit":"Ticket","value":1}},{"resourceType":"Reward","id":"e9f79562-960c-4141-bfcc-5029aacc17a0","patient":{"reference":"Patient/0f8f87d4-6fbf-4585-87c5-2a0518d18a14"},"rewardType":"Ticket","drawing":{"reference":"Drawing/c7ebbcf1-785a-4d63-a5ec-e45a8521da7c"},"status":"Active","awardDate":"2019-12-10T06:04:04Z","ticketNo":"651-856-7148","email":"yshublikar@chirpn.com","valueQuantity":{"unit":"Ticket","value":1}},{"resourceType":"Reward","id":"e9f79562-960c-4141-bfcc-5029aacc17a0","patient":{"reference":"Patient/0f8f87d4-6fbf-4585-87c5-2a0518d18a14"},"rewardType":"Ticket","drawing":{"reference":"Drawing/c7ebbcf1-785a-4d63-a5ec-e45a8521da7c"},"status":"Active","awardDate":"2019-12-10T06:04:04Z","ticketNo":"651-856-7148","email":"yshublikar@chirpn.com","valueQuantity":{"unit":"Ticket","value":1}},{"resourceType":"Reward","id":"e9f79562-960c-4141-bfcc-5029aacc17a0","patient":{"reference":"Patient/0f8f87d4-6fbf-4585-87c5-2a0518d18a14"},"rewardType":"Ticket","drawing":{"reference":"Drawing/c7ebbcf1-785a-4d63-a5ec-e45a8521da7c"},"status":"Active","awardDate":"2019-12-10T06:04:04Z","ticketNo":"651-856-7148","email":"yshublikar@chirpn.com","valueQuantity":{"unit":"Ticket","value":1}},{"resourceType":"Reward","id":"e9f79562-960c-4141-bfcc-5029aacc17a0","patient":{"reference":"Patient/0f8f87d4-6fbf-4585-87c5-2a0518d18a14"},"rewardType":"Ticket","drawing":{"reference":"Drawing/c7ebbcf1-785a-4d63-a5ec-e45a8521da7c"},"status":"Active","awardDate":"2019-12-10T06:04:04Z","ticketNo":"651-856-7148","email":"yshublikar@chirpn.com","valueQuantity":{"unit":"Ticket","value":1}},{"resourceType":"Reward","id":"e9f79562-960c-4141-bfcc-5029aacc17a0","patient":{"reference":"Patient/0f8f87d4-6fbf-4585-87c5-2a0518d18a14"},"rewardType":"Ticket","drawing":{"reference":"Drawing/c7ebbcf1-785a-4d63-a5ec-e45a8521da7c"},"status":"Active","awardDate":"2019-12-10T06:04:04Z","ticketNo":"651-856-7148","email":"yshublikar@chirpn.com","valueQuantity":{"unit":"Ticket","value":1}}];

  timeleft: any = {
    days: '00', 
    hours: '00', 
    minutes: '00', 
    seconds: '00'
  };

  isSearchTickets = false;
  searchTicketLoader = false;
  ticketBox: any = {
    loaderMsg: '',
    successMsg: '',
    failMsg: ''
  }
  
  constructor(private httpService: HttpService,
    private FB: FormBuilder,
    private _snackBar: MatSnackBar,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private loader: LoaderService,
    private auth0Service: Auth0Service) {}

  ngOnInit() {
    this.redeemPointForm = this.FB.group({
      points: ['', [Validators.required]]
    })

    this.loader.progressLoader.subscribe(state => {
      this.showLoader = state;
    })
    this.getParams();
  }

  /**
   * This function is use to read the params from the url
   */
  getParams() {
    this.paramsData = this.activeRoute.snapshot.queryParams as ParamsData;
    this.auth0Service.setTokenFromLandingPage(this.paramsData.token, this.paramsData.type)
    // Check the drawing id
    this.loader.show('progress');
    if (this.paramsData.drawingId) {
      this.getDrawing(this.paramsData.drawingId)
    }else{
      this.loader.hide('progress');
      this.router.navigateByUrl('**');
    } 
  }

/**
 * This function is used to get the drawing details by using drawing Id
 * @param drawingId 
 */
  getDrawing(drawingId) {
    const url = `drawing/${drawingId}`;

    this.httpService.get_landing_page(url)
      .subscribe((response: any) => {
        this.drawingDetails = response;
        this.searchRaffleTickets();
        this.awardRuleDeatils = this.drawingDetails.awardRule[0] || {};
        if(response.runStatus === 'Not Run')
          this.setTimer(this.drawingDetails.runDate);
        this.loader.hide('progress');
      },
        error => {
          console.log("error", error)
          this.loader.hide('progress');
        })
  }

  /**
   * This function is used to search the raffle tickets for particular user
   */
  searchRaffleTickets() {
    // this.rewards = [];
    const url = `reward/findTicketForPatient?drawing=${this.drawingDetails.id}&email=yshublikar@chirpn.com`;
    this.httpService.get_landing_page(url)
      .subscribe((response: any) => {
        this.rewards = this.formatRewardData(response);
        console.log("rewards", this.rewards)
      },
      error => {
        console.log("error while fetching  tickets", error)
      })
  }

/**
 * This function is use to redeem the points and get the tickets 
 * @param event 
 */
  redeemPoints(event) {
    event.preventDefault();
    this.searchTicketLoader = true;
    this.isSearchTickets = true;
    this.ticketBox.loaderMsg = 'Waiting for result';
    this.rewardTicket = [];
    if (this.redeemPointForm.valid) {
      const points = this.redeemPointForm.get('points').value;
      const url = `drawing/ticket/redeem`;
      const data = {
        "drawing": this.drawingDetails.id,
        "amount": parseInt(points)
      }
      const availablePoints = this.checkAvailablePoints(data.amount);
      if(availablePoints.valid){
        this.httpService.post_landing_page(url, data)
          .subscribe((response: any) => {
          if(response){
              this.rewardTicket = this.formatRewardData(response) || [];
              this.rewardTicket = this.getLatestTickets(this.rewardTicket);
              this.searchRaffleTickets()
              this.redeemPointForm.reset();
              if(this.rewardTicket.length){
                this.ticketBox.successMsg = `Congratulations!! you have earned ${this.rewardTicket.length} tickets`;
              }else{
                this.ticketBox.failMsg = 'Something went wrong please try after some time!!';
              }
            }else {
              this.redeemPointForm.reset();
              this.ticketBox.failMsg = 'You have already redeemed points for this drawing';
            }
            this.searchTicketLoader = false;
            console.log("response",response);
          },
            error => {
              this.ticketBox.failMsg = error || 'Something went wrong, please try after some time!!';
              this.searchTicketLoader = false;
          })
        }else{
          this.searchTicketLoader = false;
          this.ticketBox.failMsg = availablePoints.message;
        }
    } else {
      this._snackBar.open('Please enter points to redeem', '', {
        duration: 2000,
        verticalPosition: 'top',
        horizontalPosition: 'start'
      });
    }
  }

  /**
   * Its filter the tickets 
   */
  getLatestTickets(tickets){
    return tickets.filter(item=>{
      return this.rewards.findIndex(x=> x.ticketNo===item.ticketNo) ===-1;
    })
  }

  /**
   * It will check the points
   */
  checkAvailablePoints(points){
    const awardPoints = this.awardRuleDeatils&&this.awardRuleDeatils.rewardValue || 0;
    return {
      valid: points >= awardPoints,
      message: `You need to redeem minimun ${awardPoints} points for this drawing`
    }
  }

  /**
   * This function used to format the reward data
   */
  formatRewardData(data) {
    data && data.length && data.map(reward => {
      if (reward.rewardType === 'Ticket' || reward.rewardType === 'Points') {
        reward.rewardValue = reward.valueQuantity.value;
      } else if (reward.rewardType === 'Money') {
        reward.rewardValue = reward.valueMoney.value
      }
      return true;
    })
    return data;
  }

  hideSearchBox(event){
    this.isSearchTickets = false;
  }

  /**
   * This function is used to show the timer on UI
   * @param date 
   */
  setTimer(date) {
    const countDownDate = new Date(date).getTime();

    const timer = source.subscribe(val => {

      const now = new Date().getTime();

      // Find the distance between now and the count down date
      const distance = countDownDate - now;
      // Time calculations for days, hours, minutes and seconds
      const days = this.prependZero(Math.floor(distance / (1000 * 60 * 60 * 24)));
      const hours = this.prependZero(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
      const minutes = this.prependZero(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
      const seconds = this.prependZero(Math.floor((distance % (1000 * 60)) / 1000));

      this.timeleft = { days, hours, minutes, seconds };

      // If the count down is over, write some text 
      if (distance < 0) {
        timer.unsubscribe();
      }
    });
  }

  prependZero(time) {
    if (time <= 0 || isNaN(time)) {
      return '00'
    } else if (time > 0 && time <= 9) {
      return '0' + time;
    }
    return time;
  }

}